'use client';

import { c as _c } from "react/compiler-runtime";
import { refreshDdosStatus } from '@shared/utils/helpers/ddosStatus';
import useDdosStatus from '@shared/utils/hooks/useDdosStatus';
import useUser from '@shared/utils/hooks/useUser';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { ddosRedirectFor } from '../../helpers/ddosRedirect';
import { useLocationPathname } from '../../hooks/useLocationSearchParam';
import { client } from '../../utils/trpc';

// DDoS mode on the web (.specs/ddos-mode.md). Renders nothing: it asks the
// server who may use the site right now and moves the visitor accordingly — a
// logged-out one to /login, a signed-in one who has not verified as human to
// /biometric-verification. The rules, and why they cannot loop, are in
// helpers/ddosRedirect.ts.
//
// The status lives in a store outside React, which the tRPC link also writes
// when a call comes back refused, so a flag flipped mid-session moves the
// visitor on their next call without a reload.
const DdosGate = () => {
  const $ = _c(8);
  const router = useRouter();
  const {
    currentUser
  } = useUser();
  const {
    access
  } = useDdosStatus();
  const pathname = useLocationPathname();
  const isAuthenticated = currentUser.isAuthenticated;
  let t0;
  if ($[0] !== isAuthenticated) {
    t0 = [isAuthenticated];
    $[0] = isAuthenticated;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(_temp, t0);
  let t1;
  let t2;
  if ($[2] !== access || $[3] !== isAuthenticated || $[4] !== pathname || $[5] !== router) {
    t1 = () => {
      if (pathname === null) {
        return;
      }
      const target = ddosRedirectFor({
        access,
        isAuthenticated,
        pathname,
        search: window.location.search
      });
      if (target) {
        router.replace(target);
      }
    };
    t2 = [access, isAuthenticated, pathname, router];
    $[2] = access;
    $[3] = isAuthenticated;
    $[4] = pathname;
    $[5] = router;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  return null;
};
export default DdosGate;
function _temp() {
  refreshDdosStatus(client);
}